import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_postdoc-judicial/artifacts/ppjh7riu_EJE.png";

export default function Header({ variant = "default" }) {
  const isLight = variant === "light";
  return (
    <header
      className={`w-full border-b ${
        isLight ? "bg-white border-slate-200" : "bg-eje text-white border-eje-800"
      }`}
      data-testid="site-header"
    >
      <div className="container-wide flex items-center justify-between py-4">
        <Link
          to="/"
          className="flex items-center gap-3 group"
          data-testid="header-home-link"
        >
          <img
            src={LOGO_URL}
            alt="Escuela Judicial Electoral"
            className={`h-12 w-12 object-contain ${
              isLight ? "" : "bg-white rounded-sm p-0.5"
            }`}
          />
          <div className="leading-tight">
            <div
              className={`font-serif text-lg md:text-xl ${
                isLight ? "text-eje" : "text-white"
              }`}
            >
              Escuela Judicial Electoral
            </div>
            <div
              className={`text-[10px] tracking-[0.18em] uppercase ${
                isLight ? "text-slate-500" : "text-white/70"
              }`}
            >
              Tribunal Electoral del Poder Judicial de la Federación
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          <a
            href="https://www.te.gob.mx/eje/media/pdf/5f98124ffd93c96.pdf"
            target="_blank"
            rel="noreferrer"
            className={`hover:opacity-80 transition-opacity ${
              isLight ? "text-slate-700" : "text-white/90"
            }`}
            data-testid="nav-home"
          >
            Convocatoria
          </a>
          <Link
            to="/inscripcion"
            className={`hover:opacity-80 transition-opacity ${
              isLight ? "text-slate-700" : "text-white/90"
            }`}
            data-testid="nav-inscripcion"
          >
            Inscripción
          </Link>
          <Link
            to="/admin/login"
            className={`hover:opacity-80 transition-opacity ${
              isLight ? "text-slate-700" : "text-white/90"
            }`}
            data-testid="nav-admin"
          >
            Acceso administrador
          </Link>
        </nav>
      </div>
    </header>
  );
}
